import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/stores/auth'
import './assets/css/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)

// Note: La permission de notification sera demandée depuis un gestionnaire d'événements utilisateur
// (par exemple, un clic sur un bouton) pour respecter les règles du navigateur

// Vérifier la session au démarrage
const authStore = useAuthStore()
if (authStore.isAuthenticated) {
  // Vérifier si le token est encore valide
  if (!authStore.validateSession()) {
    // La session est expirée, logout() a été appelé par validateSession
    console.warn('Session expirée détectée au démarrage')
  }
}

// Vérification périodique de la session (toutes les 5 minutes)
if (typeof window !== 'undefined') {
  setInterval(() => {
    if (authStore.isAuthenticated && !authStore.validateSession()) {
      // La session est expirée - notification déjà affichée par validateSession via l'intercepteur
      console.warn('Session expirée - Déconnexion automatique effectuée')
    }
  }, 5 * 60 * 1000) // 5 minutes
}

app.mount('#app')

